import { formatNumber } from "@/tool/utils";
import arrow from "@assets/arrow.svg";
import { Empty, Popover } from "antd";
import { Popover as H5Popover } from "antd-mobile";
import { useMemo, useState } from "react";
import emptySvg from "@assets/empty.svg";

export default function Index({
  text,
  value,
  detail,
}: {
  text: string;
  value: string;
  detail?: any[];
}) {
  const itemElm = useMemo(() => {
    return detail && detail.length > 0 ? (
      detail.map((item) => {
        return (
          <div className="subChainItem-row">
            <div>
              <div>{item.rsymbol}</div>
              <div>${formatNumber(item.stakeValue, { decimals: 2 })}</div>
            </div>
          </div>
        );
      })
    ) : (
      <div className="subChainItem-empty">
        <Empty image={emptySvg} description="Oops, there is nothing here" />
      </div>
    );
  }, [detail]);

  const [showItem, setShowItem] = useState<boolean>(false);

  const isMobile: any = localStorage.getItem("isMobile");
  if (isMobile == 1) {
    return (
      <H5Popover
        content={itemElm}
        placement="bottom-start"
        className="h5SubChainItemContainer"
        trigger="click"
        onVisibleChange={(bo) => {
          setShowItem(bo);
        }}
      >
        <div className={`chainItem ${showItem ? "active" : ""}`}>
          <div className="chainItem-left">{text}</div>
          <div className="chainItem-right">
            {value} <img src={arrow} className={showItem ? "show" : ""} />
          </div>
        </div>
      </H5Popover>
    );
  }
  return (
    <>
      <Popover
        // color="rgba(23, 38, 54, 0.15)"
        placement="bottom"
        overlayClassName="subChainItemContainer"
        content={itemElm}
        trigger="click"
        onOpenChange={(bo) => {
          setShowItem(bo);
        }}
        // transitionName="slide-up"
        motion={{ motionName: "zoom-left" }}
      >
        <div className={`chainItem ${showItem ? "active" : ""}`}>
          <div className="chainItem-left">{text}</div>
          <div className="chainItem-right">
            {value} <img src={arrow} className={showItem ? "show" : ""} />
          </div>
        </div>
        {/* {showItem &&  */}
      </Popover>
    </>
  );
}
